export default "__VITE_ASSET__7886fabc__"